<script>
import { mapState, mapGetters } from "vuex";
import Loader from "@/components/_base/Loader";

import Card from "./Card/Index";
import AlmostEmpty from "./AlmostEmpty";
import Empty from "./Empty";
import LoadMore from "./LoadMore";
import Sugestion from "./Sugestion";

export default {
  components: {
    Card,
    AlmostEmpty,
    Empty,
    LoadMore,
    Sugestion,
    Loader
  },

  methods: {
    lowProfessionalCount() {
      return (
        this.avaliableProfessionals.length &&
        this.avaliableProfessionals.length < 3
      );
    }
  },

  computed: {
    ...mapState("orderScheduler", [
      "preloader",
      "professionalId",
      "sugestionPreloader",
      "sugestionSearch",
      "canLoadMore"
    ]),
    ...mapGetters("orderScheduler", [
      "avaliableProfessionals",
      "sugestionProfessional"
    ])
  }
};
</script>

<template>
  <div class="professional-list">
    <div class="loader" v-if="preloader">
      <Loader  />
      <p>Procurando profissionais...</p>
    </div>

    <Empty
      v-else-if="!avaliableProfessionals.length || sugestionSearch"
    />

    <div v-if="avaliableProfessionals.length"  class="list">
      <Card
        v-for="(professional, index) in avaliableProfessionals"
        :index="index"
        :key="professional.id"
        :professional="professional"
        :shouldApplyFocus="Boolean(professionalId)"
        :isSelected="professional.id === professionalId"
      />
    </div>

    <LoadMore v-if="canLoadMore" />

    <Sugestion v-if="!canLoadMore && sugestionProfessional" :professional="sugestionProfessional">
      <template slot="card">
        <Card
          :index="null"
          :key="sugestionProfessional.id"
          :professional="sugestionProfessional"
          :shouldApplyFocus="Boolean(professionalId)"
          :isSelected="sugestionProfessional.id === professionalId"
          :sugestion="true"
        />
      </template>
    </Sugestion>

    <AlmostEmpty v-if="lowProfessionalCount() && !sugestionSearch" />
  </div>
</template>

<style scoped>
.professional-list {
  position: relative;
}

.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.empty > p {
  text-align: center;
}

.list > *:not(:first-child) {
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalList/Index.vue